import axios from 'axios';
import {
  GET_LESSONS,
  GET_LESSONS_LIST,
  GET_LESSONS_MINIMAL,
  GET_LESSON,
  ADD_LESSON,
  DELETE_LESSON,
  UPDATE_LESSON,
  LESSONS_LOADING,
  LESSON_LOADING,
  CLEAR_CURRENT_LESSON,
  SET_LESSONS_PAGE
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get lightweight lessons list with pagination and filtering (for table display)
export const getLessonsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setLessonsLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;
  
  if (filters.title && filters.title.length > 0) {
    queryParams += `&title=${filters.title.join(',')}`;
  }
  if (filters.tags && filters.tags.length > 0) {
    queryParams += `&tags=${filters.tags.join(',')}`;
  }

  axios
    .get(`/api/lessons/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_LESSONS_LIST, payload: res.data }))
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({ type: GET_LESSONS_LIST, payload: { lessons: [] } });
    });
};

// Get single lesson by ID (for view/edit pages)
export const getLesson = (id) => (dispatch, getState) => {
  dispatch(setLessonLoading());
  axios
    .get(`/api/lessons/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_LESSON, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current lesson
export const clearCurrentLesson = () => {
  return { type: CLEAR_CURRENT_LESSON };
};

// Get minimal lessons list (for dropdowns/selectors - returns only _id and title)
export const getLessonsMinimal = () => (dispatch, getState) => {
  dispatch(setLessonsLoading());
  axios
    .get('/api/lessons/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_LESSONS_MINIMAL, payload: res.data }))
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({ type: GET_LESSONS_MINIMAL, payload: [] });
    });
};

// DEPRECATED: Use getLessonsList() instead
export const getLessons = () => (dispatch, getState) => {
  dispatch(setLessonsLoading());
  axios
    .get('/api/lessons', tokenConfig(getState))
    .then(res => dispatch({ type: GET_LESSONS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const addLesson = lesson => (dispatch, getState) => {
  axios
    .post('/api/lessons', lesson, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_LESSON, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const updateLesson = (id, lesson) => (dispatch, getState) => {
  axios
    .put(`/api/lessons/${id}`, lesson, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_LESSON, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const deleteLesson = id => (dispatch, getState) => {
  axios
    .delete(`/api/lessons/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_LESSON, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const setLessonsLoading = () => {
  return { type: LESSONS_LOADING };
};

export const setLessonLoading = () => {
  return { type: LESSON_LOADING };
};

// Set current page number (without fetching data)
export const setLessonsPage = (page) => {
  return { type: SET_LESSONS_PAGE, payload: page };
};
